// components/PaymentModal.js
import React from 'react';

const PaymentModal = ({
  show,
  onClose,
  onSubmit,
  name,
  email,
  phone,
  service,
  onChange,
}) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        paddingTop: "50px",
        background: "rgba(255, 255, 255, 0.9)",
        zIndex: 1000,
      }}
    >
      <div className="contact-form--1">
        <div className="row row--35 d-flex justify-content-center align-items-center">
          <div className="col-md-6 order-2 order-lg-1">
            <div className="section-title text-left">
              <h3 className="title">Payment Form</h3>
              <p className="description">
                Please fill out the form below to proceed with your payment for <b><i>{service}</i></b>.
              </p>
            </div>
            <div className="form-wrapper">
              <form onSubmit={onSubmit}>
                <label htmlFor="modalName">
                  <input
                    type="text"
                    id="modalName"
                    name="name"
                    value={name}
                    onChange={onChange}
                    placeholder="Your Name *"
                  />
                </label>

                <label htmlFor="modalEmail">
                  <input
                    type="text"
                    id="modalEmail"
                    name="email"
                    value={email}
                    onChange={onChange}
                    placeholder="Your Email *"
                  />
                </label>

                <label htmlFor="modalPhone">
                  <input
                    type="text"
                    id="modalPhone"
                    name="phone"
                    value={phone}
                    onChange={onChange}
                    placeholder="Your Phone Number *"
                  />
                </label>

                <label htmlFor="modalPhone">
                  <input
                    type="text"
                    id="modalService"
                    name="service"
                    value={service}
                    onChange={onChange}
                    placeholder="Selected Service *"
                    readOnly="true"
                  />
                </label>

                <button
                  className="rn-button-style--2 btn-solid mr-2"
                  type="submit"
                >
                  Complete Purchase
                </button>

                {/* <button
                  className="rn-button-style--2 btn-primary-color float-right"
                  type="button"
                  onClick={onClose}
                >
                  Cancel
                </button> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
